import { ElementFlags } from "typescript";
import { User } from "../Interface/IUser";

class AppHelper {
  static isNullorEmpty = (value: any) => {
    if (value == undefined || value === "" || value.trim().length == 0) {
      return true;
    }
    return false;
  };

  static isNullorEmptyNumber = (value: any) => {
    debugger;
    if (value == undefined || value === null || value === 0 || value == "") {
      return true;
    }

    // if (typeof value === "string") {
    //   if (value == "") {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }

    return false;
  };

  static isNumber = (value: any) => {
    debugger;
    return !isNaN(+value);
  };

  static validateEmail = (email: string) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  static validateLink = (link: string) => {
    return link.match(
      /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/
    );
  };

  static validatePhone = (Phone: string) => {
    if (Phone.trim().length < 26) {
      return true;
    } else {
      return false;
    }
  };

  static validatePassword = (password: string) => {
    return password.match(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
    );
  };

  static getUser = () => {
    let user: User = {
      id: 0,
      username: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
      password: "",
      email: "",
      createdBy: "",
      isActive: true,
      isMDMActive:false,
      roleID: "",
      userType: "",
      passwordResetRequired: false,
      passwordResetAlertMessage: "",
      token: "",
      mdmAccesses:[],
    };
    if (localStorage.getItem("user-info-lpa") !== null) {
      var currentUser = JSON.parse(
        localStorage.getItem("user-info-lpa") || " "
      );
      if (currentUser !== " ") {
        return currentUser;
      }
    }
    return user;
  };

  static requestOptions = (method: string) => {
    const requestOptions = {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AppHelper.getUser().token,
      },
    };
    return requestOptions;
  };

  static isUserLogin = () => {
    if (AppHelper.getUser().id === 0) {
      window.location.href = "/";
    } else {
      if (
        AppHelper.getUser().userType === "External User" &&
        AppHelper.getUser().passwordResetRequired === true
      ) {
        window.location.href = "/ResetPassword";
      }
    }
  };

  static isAdminUser = () => {
    if (AppHelper.getUser().id === 0) {
      window.location.href = "/";
    } else {
      if (AppHelper.getUser().userType !== "Admin"){
      // alert(AppHelper.getUser().userType);
        window.location.href = "/";
      }
    }

    //return true;
  };
  static isSuperAdminUser = () => {
    if (AppHelper.getUser().id === 0) {
      window.location.href = "/";
    } else {
      if (AppHelper.getUser().userType !== "Super Admin"){
        //alert(AppHelper.getUser().userType);
        window.location.href = "/";
      }
    } 
  };
  static getQueryValue() {
    return new URLSearchParams(window.location.search);
  }
}


export default AppHelper;
